import axios from 'axios';
import store from '@/store';

const urlPath = '/dps/door';

export default {
  async openDoorEntry(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      let obj = {
        message: 'openDoorEntry'
      };
      if (process.env.NODE_ENV === 'development') {
        setTimeout(() => {
          callback(obj);
        }, 3000);
      } else {
        let resp = await axios.get(`${apiUrl}${urlPath}/entry`, {
          params: params
        });
        callback(resp.data);
      }
    } catch (error) {
      console.log(error);
      if (error.data && error.data.message) {
        errorCallback(error.data.message);
      } else {
        errorCallback('');
      }
    }
  },
  async openDoorExit(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost;
    let resp;
    try {
      let obj = {
        message: 'openDoorExit'
      };
      if (process.env.NODE_ENV === 'development') {
        setTimeout(() => {
          callback(obj);
        }, 3000);
      } else {
        resp = await axios.get(`${apiUrl}${urlPath}/exit`, {
          params: params
        });
        callback(resp.data);
      }
    } catch (error) {
      console.log(error);
      if (error.data && error.data.message) {
        errorCallback(error.data.message);
      } else {
        errorCallback('');
      }
    }
  },
  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost;
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/list`, {
        params: params
      });
      callback(resp.data);
    } catch (error) {
      console.log(error);
      errorCallback();
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/doorService.js